
import React, { useState, useEffect, useRef } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Toast } from 'primereact/toast';

import axios from 'axios';

export default function ReloadAction({config, setConfig, setSelectedParamIds, setParamUpdates, setReachedConfig, setNumLevels}){

    const [pastRuns, setPastRuns] = useState([{"_id":"","date":"",'name':""}]);//The list of past runs done on the model loaded
    const [selectedConfig, setSelectedConfig] = useState(null);//just highlight which row was selected in the datatable
    const skips = new Set(['gid','name','type','parameter']);//keys from config experiment inputs that don't get pushed to updateParams 
    const op = useRef(null);
    const toast = useRef(null);
    const [filters, setFilters] = useState({name: { value: null, matchMode: FilterMatchMode.STARTS_WITH }});
    const [loading, setLoading] = useState(true);//data needs to load in


    const reloadConfig = (e) => {
        op.current.hide();
        console.log(e.data)
        axios.post(`/api/custom_query`,{
            "collection":"Experiments",
            "pipeline":[{"$match":{"$expr":{"$eq":["$_id",{"$toObjectId":e.data['_id']}]}}},{"$project":{"config":1,"_id":0}}]//gets the config of the user's selected collection to reload
        }).then(res => {
            
            const reloadedExperiment = res.data[0]['config']['experiment'];
            const experiment_config = reloadedExperiment['input'];
            const selectedParams = new Array(experiment_config.length);//creates the array used to determine what is checked in Avaiable Parameters
            const updateParams = {};//creates the map that reloads the user inputs in the experimentation table
            var index = 0;
            for (const ele of experiment_config){
                var id="";
                //if a reasource or an action time then can just pull start from these parameters
                if (ele['type']=="resource" || (ele['type']=="action" && ele["parameter"]=="time")){
                    id = ele["type"]+"-"+ele['gid']+"-"+ele["parameter"];//for each item in experiment config recraft
                }
                else if (ele['type']=="action"){//only action left is action resource request amounts
                    id = ele["type"]+"-"+ele['gid']+"-request-"+ele["param_arg"];
                }
                else{//entity's type uses entity_type, entity- needs to be hard-coded in
                    if (ele["parameter"]=='entities_per_arrival'){//then ending for this id was spelt a bit differently than the parameter
                        id = "entity-"+ele['gid']+'-entities-per-arrival';
                    }
                    else{
                        id = "entity-"+ele['gid']+'-'+ele["parameter"];
                    }
                }
                selectedParams[index]=id;
                index = index+1;
                updateParams[id]={}
                for(var key in ele){
                    if(!skips.has(key))
                        updateParams[id][key]=ele[key]//pulls the elements needed for the experiment tables
                }
            }
            // Keep Number of Levels in sync with the reloaded values
            if (reloadedExperiment['type'] === 'Factorial') {
                const reloadedNumLevels = Object.values(updateParams).reduce(
                    (max, param) => Math.max(max, (param.values || []).length), 2
                );
                setNumLevels(reloadedNumLevels);
            }

            setParamUpdates(updateParams);
            setSelectedParamIds(selectedParams);
            setConfig(res.data[0]['config']);
            setReachedConfig(preState => preState + 1);
            
        })
        .catch(err => {
        console.error(err);
        })
        //toast.current.show({ severity: 'info', summary: 'Product Selected', detail:e.data.model_name, life: 3000 }); 
    };

    const getPastRuns = (e) => {
        /*Gets the past runs for user to select on button click */
        axios.get(`api/reload_options/${config.model_name}`)
        .then(res => {
        setPastRuns(res.data);//values will appear in data table
        op.current.toggle(e);//reveal data-table
        })
        .catch(err => {
        console.error(err);
        })
        setLoading(false);//data is no longer loading
    };

    return(
        <>
            <Toast ref={toast} />
            <Button style={{marginLeft: "10%"}} size="small" label="Reload Past Configs" onClick={(e)=>getPastRuns(e)}/>
            <OverlayPanel ref={op} showCloseIcon closeOnEscape dismissable={false}>
                <DataTable value={pastRuns} scrollable scrollHeight="50rem" style={{ minWidth: '50rem' }} 
                selectionMode="single" 
                selection={selectedConfig} onSelectionChange={(e) =>setSelectedConfig(e.value)}  onRowClick={reloadConfig}
                filters={filters} filterDisplay='row' loading={loading} globalFilterFields={['name']} emptyMessage="No data found">
                    <Column field="name" header="Name" filter filterPlaceholder='Search By Name' sortable style={{ width: '25%' }}/>
                    <Column field="date" header="Date" dataType='date' sortable style={{ width: '25%' }}/>
                    <Column field="_id" header="id"/>
                </DataTable>
            </OverlayPanel>
        </>
    );

}